import React from 'react';
import TabWrapper from '../../components/TabWrapper/TabWrapper';

function RestaurantsRoute() {
  return (
    <div>
      <TabWrapper />
    </div>
  );
}

export default RestaurantsRoute;
